import {
    TFeatureRestrictions,
    TFeatureVariation
} from '~/components/FeatureRestriction/types/feature-restriction.types';
import { Account } from '~/models/account.model';
import { Company } from '~/models/company.model';

export const featureVariationsToFeatureRestrictionMap = (
    features: TFeatureVariation[],
    company?: Company,
    account?: Account
) => {
    return features?.reduce((restrictions, featureVariation) => {
        const { key, variation } = featureVariation;

        if (variation === 'on') {
            restrictions[key] = false;
            return restrictions;
        }

        if (variation === 'off') {
            restrictions[key] = true;
            return restrictions;
        }

        if (key === 'team_members') {
            if (variation === 'unlimited') {
                restrictions[key] = false;
                return restrictions;
            }

            let isRestricted = false;
            const maxTeamMemberCount = Number(variation);

            if (!isNaN(maxTeamMemberCount) && company) {
                const enabledTeamMembersCount =
                    company.enabledTeamMembers.length;
                isRestricted = enabledTeamMembersCount >= maxTeamMemberCount;
            }

            restrictions[key] = isRestricted;
            return restrictions;
        }

        if (key === 'scheduler') {
            let isRestricted = false;
            if (!isNaN(+variation) && company) {
                const activeSessionsCount =
                    company.activeSessionConfigs?.length || 0;
                isRestricted = activeSessionsCount >= +variation;
            }

            restrictions[key] = isRestricted;
            return restrictions;
        }

        if (key === 'lead_forms') {
            let isRestricted = true;
            if (variation === 'unlimited') {
                restrictions[key] = false;
                return restrictions;
            }
            if (
                !isNaN(+variation) &&
                account?.publishedLeadFormsCount < +variation
            ) {
                isRestricted = false;
            }

            restrictions[key] = isRestricted;
            return restrictions;
        }

        restrictions[key] = true;
        return restrictions;
    }, {} as TFeatureRestrictions);
};
